import React, { MouseEvent, FC, useMemo } from "react";
import { UiLoader } from "@ui-monorepo/index";
import { useGlobalStyles } from "~/styles/context/global-styles-wrapper";
import { ButtonType, UiButtonProps } from "./types";
import styles from "./ui-button.module.css";
import { TemplateType } from "../../styles/constants/template-type";
import {
  ButtonRoundedClass,
  ButtonRoundedEnum } from
"../../common/props/orchestrator";

const UiButton: FC<UiButtonProps> = ({
  appearance = "normal",
  isFilled = false,
  isWhite = false,
  isBlack = false,
  isSecondary = false,
  isTertiary = false,
  isSpecial = false,
  size = "normal",
  hasPersonalization,
  className,
  disabled,
  isLoading,
  children,
  leftIcon,
  rightIcon,
  onClick
}) => {
  const { theme } = useGlobalStyles();
  const rounded = useMemo(
    () =>
    theme?.config?.button?.rounded === ButtonRoundedEnum.full ?
    ButtonRoundedClass.rounded :
    theme?.config?.button?.rounded === ButtonRoundedEnum.semi ?
    ButtonRoundedClass.mid_rounded :
    theme?.config?.button?.rounded === ButtonRoundedEnum.square ?
    ButtonRoundedClass.square :
    "",
    [theme]
  );

  const buttonType =
  theme.template.BUTTON === TemplateType.BUTTON_1 ?
  ButtonType.Button1 :
  theme.template.BUTTON === TemplateType.BUTTON_2 ?
  ButtonType.Button2 :
  ButtonType.Button1;

  const handleClick = (e?: MouseEvent<HTMLButtonElement>) => {
    if (!disabled && onClick) onClick(e);
  };

  return (
    <button
      type='button'
      className={`
				${styles.buttonWrapper} 
				${styles[buttonType]} 
				${styles[rounded]} 
				${styles[appearance]} 
				${styles[size]} 
				${hasPersonalization && styles.withPersonalization} 
				${isFilled && styles.hasFill} 
				${isWhite && styles.isWhite}
				${isBlack && styles.isBlack} 
				${isSecondary && styles.isSecondary}
				${isTertiary && styles.isTertiary}
				${isSpecial && styles.isSpecial}
				${className}
			`}
      role={"button"}
      disabled={disabled}
      onClick={handleClick}>

      {!isLoading && leftIcon}
      {!!children ? !isLoading ? children : <UiLoader size={20} /> : null}
      {!isLoading && rightIcon}
    </button>);

};

export default UiButton;